import { InputProps, InputRef } from "antd";
import React, { FC } from "react";
import { BaseInput } from "@app/components/shared/form/baseComponents";

interface IProps extends Omit<InputProps, "onChange" | "value"> {
    onChange?: (v: string) => void;
    value?: string;
}
export const DigitInput: FC<IProps> = ({
    ref,
    onChange,
    ...restProps
}: IProps & {
    ref?: React.RefObject<InputRef>;
}) => {
    const handleOnChange = (arg: string) => {
        let val = arg;
        val = val.replace(/[^0-9]/g, "");
        onChange?.(val);
    };

    return <BaseInput {...restProps} onChange={handleOnChange} />;
};
